/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetOrganizationRemoteSessionIssuerDuplicatePreflightSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type GetOrganizationRemoteSessionIssuerDuplicatePreflightRequest = {
  /**
   * The upstream issuer URL being entered (e.g. https://login.linear.app). Empty or unparseable returns no matches.
   */
  issuer?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type GetOrganizationRemoteSessionIssuerDuplicatePreflightSecurity$Outbound =
  {
    "session_header_Gram-Session"?: string | undefined;
    "apikey_header_Gram-Key"?: string | undefined;
  };

/** @internal */
export const GetOrganizationRemoteSessionIssuerDuplicatePreflightSecurity$outboundSchema:
  z.ZodMiniType<
    GetOrganizationRemoteSessionIssuerDuplicatePreflightSecurity$Outbound,
    GetOrganizationRemoteSessionIssuerDuplicatePreflightSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function getOrganizationRemoteSessionIssuerDuplicatePreflightSecurityToJSON(
  getOrganizationRemoteSessionIssuerDuplicatePreflightSecurity:
    GetOrganizationRemoteSessionIssuerDuplicatePreflightSecurity,
): string {
  return JSON.stringify(
    GetOrganizationRemoteSessionIssuerDuplicatePreflightSecurity$outboundSchema
      .parse(getOrganizationRemoteSessionIssuerDuplicatePreflightSecurity),
  );
}

/** @internal */
export type GetOrganizationRemoteSessionIssuerDuplicatePreflightRequest$Outbound =
  {
    issuer?: string | undefined;
    "Gram-Session"?: string | undefined;
    "Gram-Key"?: string | undefined;
  };

/** @internal */
export const GetOrganizationRemoteSessionIssuerDuplicatePreflightRequest$outboundSchema:
  z.ZodMiniType<
    GetOrganizationRemoteSessionIssuerDuplicatePreflightRequest$Outbound,
    GetOrganizationRemoteSessionIssuerDuplicatePreflightRequest
  > = z.pipe(
    z.object({
      issuer: z.optional(z.string()),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
      });
    }),
  );

export function getOrganizationRemoteSessionIssuerDuplicatePreflightRequestToJSON(
  getOrganizationRemoteSessionIssuerDuplicatePreflightRequest:
    GetOrganizationRemoteSessionIssuerDuplicatePreflightRequest,
): string {
  return JSON.stringify(
    GetOrganizationRemoteSessionIssuerDuplicatePreflightRequest$outboundSchema
      .parse(getOrganizationRemoteSessionIssuerDuplicatePreflightRequest),
  );
}
